/**
 * Constants - Application Configuration
 */

const rawApiUrl = (import.meta.env.API_URL || import.meta.env.VITE_API_URL || '').trim();
const normalizedApiUrl = rawApiUrl.replace(/\/$/, '');
const isDevMode = import.meta.env.MODE === 'development';

// API URL from Vite environment variables
export const API_URL =
  isDevMode
    ? ''
    : normalizedApiUrl;

if (!isDevMode && !API_URL) {
  console.error('Missing API URL: set API_URL during build to avoid same-origin /api calls');
}

// Environment flags
export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;

// Application pages configuration
export const PAGES: { [key: string]: string[] } = {
  Admin: ['/users', '/administrators', '/groups', '/crawling'],
};
